/**
 PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA

 *  Copyright © 2017 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *  @Deprecated  use EventProvider instead
* */

import React from 'react';
import PropTypes from 'prop-types';
import AnalyticsManager from '../AnalyticsManager';

export default class AnalyticsProvider extends React.Component {
  constructor(props) {
    super(props);
    AnalyticsManager.setContext(props);
  }

  render() {
    const { children } = this.props;
    return (
      <div>
        {children}
      </div>
    );
  }
}
AnalyticsProvider.propTypes = {
  children: PropTypes.element.isRequired
};

AnalyticsProvider.defaultProps = {
  disableAnalytics: false, // eslint-disable-line
  onEvent: () => {} // eslint-disable-line
};



// WEBPACK FOOTER //
// ./src/js/providers/AnalyticsProvider.jsx